import iconv from 'iconv-lite';
import { Buffer } from 'buffer';

function formatRivhitDate(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
}

function getTimestamp() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${year}${month}${day}_${hours}${minutes}`;
}

/**
 * Build Rivhit tab-delimited content from transaction grid rows.
 * options:
 *  - dueDateMode: 'charge_date' | 'custom'
 *  - customDueDate: Date | dayjs | string
 *  - sortCode: number (100-999), default 100
 *  - includeVat: if true, do not divide by VAT; if false, divide
 *  - vatPercent: number, default 18
 */
export function transactionsToRivhitTabDelimited(rows, options = {}) {
  const {
    dueDateMode = 'charge_date',
    customDueDate = null,
    sortCode = 100,
    includeVat = false,
    vatPercent = 18,
  } = options;

  const vatFactor = 1 + Number(vatPercent || 0) / 100;
  const safeSortCode = Math.min(999, Math.max(100, Number(sortCode) || 100));
  const customDue = formatRivhitDate(customDueDate);

  let str = '';

  (rows || []).forEach((row) => {
    const chargeSum = Number(row.charge_sum) || 0;
    if (chargeSum <= 0) return;

    const qty = 1;
    const lineTotal = includeVat
      ? Number(chargeSum).toFixed(2)
      : Number(chargeSum / vatFactor).toFixed(2);
    const unitPrice = Number(lineTotal / qty).toFixed(4);

    const chargeDate = formatRivhitDate(row.charge_date);
    const dueDate =
      dueDateMode === 'custom' && customDue ? customDue : chargeDate;

    const custId = row.customer ?? '';
    const custName = row.name ?? '';
    const itemName = row.note || row.period || 'חיוב';
    const itemPartNum = row.period || '1';

    str += '1'; // hen_kabala_type
    str += `\t${chargeDate}`; // trnsfr_date
    str += `\t${chargeDate}`; // issu_date
    str += '\t1'; // hen_type
    str += `\t${itemPartNum}`; // item_part_num
    str += `\t${itemName}`; // item_name
    str += `\t${qty}`; // item_qtt
    str += `\t${unitPrice}`; // item_price
    str += `\t${lineTotal}`; // ttl_line
    str += `\t${custId}`; // cust_id
    str += `\t${custName}`; // cust_lname
    str += '\t'; // cust_fname
    str += '\t'; // street
    str += '\t'; // city
    str += `\t${custId}`; // internal_num
    str += `\t${dueDate}`; // due_date
    str += '\t3\t\t\t'; // pmnt_type + check_num + bank_code + snif_num
    str += `\t\t1\t\t\t${safeSortCode}`; // hen_bank_num + mtc + mtc_rate + mtc_item_price + sort_code
    str += `\t${row.asc_num ?? ''}`; // internal_order
    str += '\t\t'; // price_bruto + id_number
    str += '\n';
  });

  return str;
}

export function downloadRivhitTxt(content, fileName) {
  if (!content) return false;

  if (typeof window !== 'undefined' && !window.Buffer) {
    window.Buffer = Buffer;
  }

  const ansiEncodedData = new Uint8Array(iconv.encode(content, 'windows-1255'));
  const blob = new Blob([ansiEncodedData], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || `Rivhit_${getTimestamp()}.txt`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return true;
}

export function exportTransactionsToRivhit(rows, options = {}) {
  const content = transactionsToRivhitTabDelimited(rows, options);
  if (!content) return false;
  return downloadRivhitTxt(content, `Rivhit_${getTimestamp()}.txt`);
}
